module.exports = __webpack_public_path__ + "static/Customer1-7ab9ccda5e020c97dbb6bc7b599fcb8b.png";